import Head from 'next/head';

export const usePageTitle = (customTitle?: string) => {

  const getPageTitle = () => {
    if (customTitle) {
      return customTitle;
    }
    return 'Pincho Nation Booking';
  };

  const PageTitle = () => {
    const title = getPageTitle();
    
    return (
      <Head>
        <title>{title}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
    );
  };

  return { PageTitle, getPageTitle };
}; 